import { AccountStatus, MfaMethod, MfaPolicyValue, SpendFrequency } from "src/types/commonTypes";

export const SUPPORTER = "SUPPORTER";
export const PARTICIPANT = "PARTICIPANT";
export const INTERNAL_ADMIN = "INTERNAL_ADMIN";
export const SUPER_ADMIN = "ORGANISATION_SUPER_ADMIN";
export const OPERATIONS_MANAGER = "ORGANISATION_OPERATIONS_MANAGER";
export const FINANCE_MANAGER = "ORGANISATION_FINANCE_MANAGER";
export const LEGAL_GUARDIAN = "GUARDIAN";
export const PARTICIPANT_SELF_MANAGED = "PARTICIPANT_SELF_MANAGED";
export const NOVATTI_DAILY_TRANSACTION = "NOVATTI_DAILY_TRANSACTION";
export const NOVATTI_CARD_TRANSACTION = "NOVATTI_CARD_TRANSACTION";
export const WALLET_TRANSACTION = "WALLET_TRANSACTION";
export const ADJUSTMENT = "ADJUSTMENT";
export const DEPOSIT_WITHDRAWAL = "DEPOSIT_WITHDRAWAL";
export const WALLET_TO_WALLET_TRANSFER = "WALLET_TO_WALLET_TRANSFER";
export const CASH_TRANSACTION = "CASH_TRANSACTION";
export const SETTLEMENT_ADJUSTMENT = "SETTLEMENT_ADJUSTMENT";
export const CORPORATE = "CORPORATE";
export const INDIVIDUAL = "INDIVIDUAL";
export const REFERER = "REFERER";
export const CREATED_FOR_SELF = "SELF";
export const CREATED_FOR_OTHER = "OTHER";
export const SHARED = "SHARED";
export const PRIVATE = "PRIVATE";
export const CAN_ADD_USER = "CAN_ADD_USER";
export const CAN_ADD_CARD = "CAN_ADD_CARD";
export const CAN_UPDATE_CARD = "CAN_UPDATE_CARD";
export const CAN_CHANGE_CARD_PIN = "CAN_CHANGE_CARD_PIN";
export const CAN_EDIT_USER_INFORMATION = "CAN_EDIT_USER_INFORMATION";
export const CAN_EDIT_TRANSACTION = "CAN_EDIT_TRANSACTION";
export const CAN_UPDATE_WALLET = "CAN_UPDATE_WALLET";
export const CAN_UPDATE_WALLET_SETTINGS = "CAN_UPDATE_WALLET_SETTINGS";
export const CAN_UPDATE_BUDGET = "CAN_UPDATE_BUDGET";
export const CAN_UPDATE_REPEAT_PAY = "CAN_UPDATE_REPEAT_PAY";
export const CAN_CONNECT_USER_TO_WALLET = "CAN_CONNECT_USER_TO_WALLET";
export const CAN_CONNECT_CARD_TO_WALLET = "CAN_CONNECT_CARD_TO_WALLET";
export const CAN_CONNECT_CARD = "CAN_CONNECT_CARD";
export const CAN_CONNECT_CARD_TO_ORGANISATION = "CAN_CONNECT_CARD_TO_ORGANISATION";
export const CAN_CONNECT_WALLET_TO_ORGANISATION = "CAN_CONNECT_WALLET_TO_ORGANISATION";
export const CAN_CONNECT_USER_TO_ORGANISATION = "CAN_CONNECT_USER_TO_ORGANISATION";
export const CAN_UPDATE_ORGANISATION = "CAN_UPDATE_ORGANSIATION";
export const CAN_CHANGE_PIN = "CAN_CHANGE_PIN";
export const CAN_UPDATE_USER_ROLE = "CAN_UPDATE_USER_ROLE";
export const CAN_UPDATE_USER_SETTINGS = "CAN_UPDATE_USER_SETTINGS";
export const CAN_UPDATE_USER_KYC = "CAN_UPDATE_USER_KYC";
export const CAN_TAGGED_USER = "CAN_TAGGED_USER";
export const CAN_CONNECT_WALLET_TO_USER = "CAN_CONNECT_WALLET_TO_USER";
export const CAN_RESET_PASSWORD = "CAN_RESET_PASSWORD";
export const CAN_ADD_WALLET = "CAN_ADD_WALLET";
export const CAN_UPDATE_EMAIL = "CAN_UPDATE_EMAIL";
export const CAN_TOGGLE_CARD_STATUS = "CAN_TOGGLE_CARD_STATUS";
export const CAN_ACT_ON_QUICK_LINKS = "CAN_ACT_ON_QUICK_LINKS";
export const CAN_ACCESS_ONBOARDING = "CAN_ACCESS_ONBOARDING";
export const CAN_DEPOSIT = "CAN_DEPOSIT";
export const CAN_DEPOSIT_TO_CASH_WALLET = "CAN_DEPOSIT_TO_CASH_WALLET";
export const CAN_REPORT_CASH_TRANSACTION = "CAN_REPORT_CASH_TRANSACTION";
export const CAN_REVERSE_CASH_TRANSACTION = "CAN_REVERSE_CASH_TRANSACTION";
export const CAN_UPGRADE_CARD = "CAN_UPGRADE_CARD";
export const CAN_TRANSFER_BETWEEN_WALLET = "CAN_TRANSFER_BETWEEN_WALLET";
export const CAN_LOAD_CARD = "CAN_LOAD_CARD";
export const CAN_VIEW_SUBSCRIPTION_PLAN = "CAN_VIEW_SUBSCRIPTION_PLAN";
export const CAN_ACCESS_ORDER_CARD_BUTTON = "CAN_ACCESS_ORDER_CARD_BUTTON";
export const CAN_CREATE_GENERAL_WALLET = "CAN_CREATE_GENERAL_WALLET";
export const CAN_CREATE_CASH_WALLET = "CAN_CREATE_CASH_WALLET";
export const CAN_SEE_HOW_TO_DEPOSIT = "CAN_SEE_HOW_TO_DEPOSIT";
export const CAN_SEE_CARD_ON_USER_DETAIL = "CAN_SEE_CARD_ON_USER_DETAIL";
export const CAN_BLOCK_MERCHANT = "CAN_BLOCK_MERCHANT";
export const CAN_BLOCK_ACCOUNT_MERCHANT = "CAN_BLOCK_ACCOUNT_MERCHANT";
export const VIEW_USER_WIDGET_IN_WALLET_DETAIL = "VIEW_USER_WIDGET_IN_WALLET_DETAIL";
export const CAN_CREATE_ORGANISATION = "CAN_CREATE_ORGANISATION";
export const CAN_CREATE_GROUP = "CAN_CREATE_GROUP";
export const CAN_CONNECT_USER_TO_GROUP = "CAN_CONNECT_USER_TO_GROUP";
export const CAN_UPDATE_GROUP = "CAN_UPDATE_GROUP";
export const CAN_CONNECT_CARD_TO_GROUP = "CAN_CONNECT_CARD_TO_GROUP";
export const CAN_TRANSFER_PARTICIPANT_TO_PARTICIPANT = "CAN_TRANSFER_PARTICIPANT_TO_PARTICIPANT";
export const CAN_TRANSFER_GROUP_TO_GROUP = "CAN_TRANSFER_GROUP_TO_GROUP";
export const CAN_TRANSFER_PARTICIPANT_TO_GROUP = "CAN_TRANSFER_PARTICIPANT_TO_GROUP";
export const CAN_TRANSFER_GROUP_TO_PARTICIPANT = "CAN_TRANSFER_GROUP_TO_PARTICIPANT";
export const CAN_TRANSFER_MASTER_TO_PARTICIPANT = "CAN_TRANSFER_MASTER_TO_PARTICIPANT";
export const CAN_TRANSFER_MASTER_TO_GROUP = "CAN_TRANSFER_MASTER_TO_GROUP";
export const CAN_UPDATE_GROUP_MANAGER = "CAN_UPDATE_GROUP_MANAGER";
export const CAN_CREATE_GROUP_WALLET = "CAN_CREATE_GROUP_WALLET";
export const CAN_LOAD_CARD_FOR_GROUP = "CAN_LOAD_CARD_FOR_GROUP";
export const CAN_CONNECT_XERO = "CAN_CONNECT_XERO";
export const CAN_ACCESS_ALL_USERS_IN_ORG = "CAN_ACCESS_ALL_USERS_IN_ORG";
export const CAN_ACCESS_ALL_TRANSACTIONS = "CAN_ACCESS_ALL_TRANSACTIONS";
export const CAN_ACCESS_RECURRING_TRANSACTION = "CAN_ACCESS_RECURRING_TRANSACTION";
export const CAN_VIEW_TRANSACTION_DETAIL = "CAN_VIEW_TRANSACTION_DETAIL";
export const CAN_UPLOAD_IMAGE_IN_TRANSACTION = "CAN_UPLOAD_IMAGE_IN_TRANSACTION";
export const CAN_ADD_NOTES_IN_TRANSACTION = "CAN_ADD_NOTES_IN_TRANSACTION";
export const CAN_CREATE_EXPENSE = "CAN_CREATE_EXPENSE";
export const CAN_CONNECT_USER_TO_EXPENSE = "CAN_CONNECT_USER_TO_EXPENSE";
export const CAN_ATTACH_CARD_TRANSACTION_TO_EXPENSE = "CAN_ATTACH_CARD_TRANSACTION_TO_EXPENSE";
export const CAN_INSTANT_DEPOSIT = "CAN_INSTANT_DEPOSIT";
export const CAN_ORDER_CARD = "CAN_ORDER_CARD";
export const CAN_BUY_SUBSCRIPTION = "CAN_BUY_SUBSCRIPTION";
export const CAN_UNLINK_USER_FROM_ORGANISATION = "CAN_UNLINK_USER_FROM_ORGANISATION";
export const CAN_APPROVE_TRANSACTION = "CAN_APPROVE_TRANSACTION";
export const CAN_VERIFY_TRANSACTION = "CAN_VERIFY_TRANSACTION";
export const CAN_MARK_TRANSACTION_AS_DRAFT = "CAN_MARK_TRANSACTION_AS_DRAFT";
export const CAN_ADD_ATTRIBUTE_CATALOG = "CAN_ADD_ATTRIBUTE_CATALOG";
export const CAN_UPDATE_LICENSE = "CAN_UPDATE_LICENSE";
export const CAN_REQUIRE_WALLET_STEP_ON_USER_CREATE = "CAN_AUTO_CREATE_WALLET_ON_USER_CREATE";
export const CAN_CREATE_REIMBURSEMENT = "CAN_CREATE_REIMBURSEMENT";
export const CAN_APPROVE_REIMBURSEMENT = "CAN_APPROVE_REIMBURSEMENT";
export const CAN_COMPLETE_REIMBURSEMENT = "CAN_COMPLETE_REIMBURSEMENT";
export const CAN_BULK_UPLOAD_CASH_TRANSACTION = "CAN_BULK_UPLOAD_CASH_TRANSACTION";
export const CAN_BULK_UPLOAD_DEPOSIT = "CAN_BULK_UPLOAD_DEPOSIT";
export const CAN_BULK_UPLOAD_CREATE_USER = "CAN_BULK_UPLOAD_CREATE_USER";
export const CAN_BULK_UPLOAD_CREATE_GL_CODE = "CAN_BULK_UPLOAD_CREATE_GL_CODE";
export const CAN_BULK_UPLOAD_CREATE_ACCOUNTING_CATEGORY = "CAN_BULK_UPLOAD_CREATE_ACCOUNTING_CATEGORY";
export const CAN_BULK_UPLOAD_UPDATE_GL_CODE = "CAN_BULK_UPLOAD_UPDATE_GL_CODE";
export const CAN_BULK_UPLOAD_UPDATE_ACCOUNTING_CATEGORY = "CAN_BULK_UPLOAD_UPDATE_ACCOUNTING_CATEGORY";

export const EMPTY_STRING = "";

export const MFA_POLICY: Record<"MANDATORY" | "OPTIONAL" | "OFF", MfaPolicyValue> = {
  MANDATORY: "MANDATORY",
  OPTIONAL: "OPTIONAL",
  OFF: "OFF"
};
export const MFA_METHOD: Record<"TOTP" | "EMAIL", MfaMethod> = {
  TOTP: "TOTP",
  EMAIL: "EMAIL"
};
export const MFA_TOTP_ISSUER = "Spendable";

export type AuthMode = "cookie" | "token";
export const AUTH_MODE: Record<"COOKIE" | "TOKEN", AuthMode> = {
  COOKIE: "cookie",
  TOKEN: "token"
};
export const DEFAULT_API_PREFIX = "/api";
// Cognito identity provider name for Google sign-in (as it appears in the pool and the session claims).
export const GOOGLE_IDENTITY_PROVIDER = "Google";
export const SSO_RETURN_TO = "/";

// Panel-local labels: ORGANISATION_FINANCE_MANAGER is shown as "Guardian" in the app, so GUARDIAN becomes "Legal guardian".
export const MFA_POLICY_ROLES: { role: string; label: string; description: string; hidden?: boolean }[] = [
  { role: SUPER_ADMIN, label: "Super Admin", description: "Full control of the organisation" },
  { role: OPERATIONS_MANAGER, label: "Operations Manager", description: "Manages users, wallets and cards" },
  { role: FINANCE_MANAGER, label: "Guardian", description: "Finance reporting and wallet oversight" },
  { role: SUPPORTER, label: "Supporter", description: "Carers and support workers who help participants" },
  {
    role: LEGAL_GUARDIAN,
    label: "Legal guardian",
    description: "Manages a participant's account on their behalf",
    hidden: true
  },
  { role: PARTICIPANT, label: "Participant", description: "Spends from their own wallets" },
  {
    role: PARTICIPANT_SELF_MANAGED,
    label: "Self-Managed Participant",
    description: "Manages their own wallets and support team",
    hidden: true
  }
];

export const CARD_CHECKOUT_ONCE = "ONCE";
export const CARD_CHECKOUT_CARD_EXPIRY = "CARD_EXPIRY";

// The one list of card checkout durations, values and labels. "ONCE" is a single transaction, "CARD_EXPIRY" lasts until
// the card expires (the backend sets the end), and the rest are hours.
export const CARD_CHECKOUT_DURATION_OPTIONS: { value: string; label: string }[] = [
  { value: CARD_CHECKOUT_ONCE, label: "One Transaction" },
  { value: "2", label: "2 Hours" },
  { value: "4", label: "4 Hours" },
  { value: "6", label: "6 Hours" },
  { value: "8", label: "8 Hours" },
  { value: "12", label: "12 Hours" },
  { value: "24", label: "24 Hours" },
  { value: "48", label: "2 Days" },
  { value: "96", label: "4 Days" },
  { value: "168", label: "1 Week" },
  { value: "2160", label: "3 Months" },
  { value: "4320", label: "6 Months" },
  { value: CARD_CHECKOUT_CARD_EXPIRY, label: "Until card expires" }
];

export const SPEND_FREQUENCY_OPTIONS: { value: SpendFrequency; label: string }[] = [
  { value: "NONE", label: "None" },
  { value: "DAILY", label: "Daily" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "BIWEEKLY", label: "Bi-weekly" },
  { value: "MONTHLY", label: "Monthly" }
];

// limit_resets_at for a weekly budget.
export const LIMIT_RESET_DAY_OPTIONS = [
  { value: "0", label: "Sunday" },
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" }
];

export const MAX_WALLET_BUDGET_LIMIT = 10000;
export const MAX_WALLET_TRANSACTION_LIMIT = 1000;
export const EMPTY_VALUE = "-";

export const TXN_REF_TRANSACTION = "transaction";

export const DEFAULT_COUNTRY_CODE = "+61";
export const DEFAULT_COUNTRY = "Australia";

export const MIN_ORG_NAME_LENGTH = 2;

// Workflow condition trees: Sydney minutes per day (minute_of_day leaves), and
// the floored-hours span of a daily scheduler age window (fires once per record).
export const MINUTES_PER_DAY = 1440;
export const CONDITION_TREE_AGE_WINDOW_SPAN_HOURS = 23;

export const SUSPICIOUS_NAME_TOKENS = ["undefined", "null"] as const;

// Event param keys never sent to GA4 (matched case-insensitively).
export const ANALYTICS_PII_KEYS: readonly string[] = [
  "name",
  "first_name",
  "last_name",
  "full_name",
  "email",
  "contact",
  "phone",
  "phone_number",
  "mobile",
  "username"
];

export const ACCOUNT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  READY: "READY",
  REJECTED: "REJECTED"
} as const;

export const BALANCE_CUTOFF_DATE = "2024-03-13T00:00:00Z";

export const DEFAULT_CURRENCY = "AUD";

export const ACCOUNT_STATUS_TRANSITIONS: Record<string, string[]> = {
  [ACCOUNT_STATUS.DRAFT]: [ACCOUNT_STATUS.SUBMITTED],
  [ACCOUNT_STATUS.SUBMITTED]: [ACCOUNT_STATUS.APPROVED, ACCOUNT_STATUS.REJECTED],
  [ACCOUNT_STATUS.APPROVED]: [ACCOUNT_STATUS.READY, ACCOUNT_STATUS.REJECTED],
  [ACCOUNT_STATUS.REJECTED]: [ACCOUNT_STATUS.SUBMITTED],
  [ACCOUNT_STATUS.READY]: []
};

export const ACTION_REQUIRED_TO_ACCOUNT_STATUS: Record<string, AccountStatus> = {
  RECEIPT_REQUIRED: ACCOUNT_STATUS.DRAFT,
  APPROVAL_REQUIRED: ACCOUNT_STATUS.SUBMITTED,
  VERIFICATION_REQUIRED: ACCOUNT_STATUS.APPROVED
};

export const permissionMapping: Record<string, string> = {
  [CAN_ADD_CARD]: CAN_ACCESS_ORDER_CARD_BUTTON
};

export const planCategoryMapping: Record<string, string> = {
  BASE: "Base",
  TOP_UP: "Top Up"
};

export const roleMapping: Record<string, string> = {
  ORGANISATION_SUPER_ADMIN: "Super Admin",
  SUPPORTER: "Supporter",
  ORGANISATION_FINANCE_MANAGER: "Guardian",
  ORGANISATION_OPERATIONS_MANAGER: "Operations Manager",
  PARTICIPANT: "Participant",
  INTERNAL_ADMIN: "Internal Admin",
  NOROLE: EMPTY_STRING
};

export const activityNameMapping: Record<string, string> = {
  NOVATTI_CARD_TRANSACTION: "Card Transaction",
  NOVATTI_DAILY_TRANSACTION: "Novatti Daily Transaction",
  WALLET_TRANSACTION: "Wallet Transaction",
  CASH_TRANSACTION: "Cash Transaction",
  DEPOSIT: "Deposit",
  CREATE_USER: "Create User"
};

export const activityStatusMapping: Record<string, string> = {
  SETTLED: "Settled",
  APPROVED: "Approved",
  DECLINED: "Declined",
  RETURNED: "Returned",
  REVERSED: "Reversed"
};

export const ACTIVITY_STATUS_FILTER_VALUES = ["SETTLED", "APPROVED", "DECLINED"];

export const reportTypeMapping: Record<string, string> = {
  ORGANISATION_DAILY_EVALUATION: "Organisation Daily Evaluation",
  LICENCE_DAILY_EVALUATION: "Licence Daily Evaluation",
  WALLET_DAILY_REPORT: "Wallet Daily Report",
  DOWNLOAD_WALLET: "Download Wallet",
  DOWNLOAD_ACTIVITY: "Download Activity",
  DOWNLOAD_CARD: "Download Card",
  WALLET_STATEMENT: "Wallet Statement"
};

export const reportStageMapping: Record<string, string> = {
  STAGE_1: "Stage 1",
  STAGE_2: "Stage 2",
  STAGE_3: "Stage 3",
  STAGE_4: "Stage 4",
  STAGE_5: "Stage 5"
};

export const bucketNameMapping: Record<string, string> = {
  ORGANISATION_REGISTERED: "Organisation Registered",
  SUBSCRIPTION_SELECTED: "Subscription Selected",
  USERS_CREATED: "Users Created",
  WALLETS_CREATED: "Wallets Created",
  PRE_TRANSACTION: "Pre Transaction",
  TRANSACTED: "Transacted"
};

export const walletTypeToActivityName: Record<string, string> = {
  GENERAL: "NOVATTI_CARD_TRANSACTION",
  SPENDING: "NOVATTI_CARD_TRANSACTION",
  DIGITAL: "NOVATTI_CARD_TRANSACTION",
  CASH: "CASH_TRANSACTION",
  SERVICE: "NOVATTI_CARD_TRANSACTION"
};

export const walletTypeMapping: Record<string, string> = {
  GENERAL: "General",
  SPENDING: "Spending",
  DIGITAL: "Digital",
  GROUP: "Group",
  CASH: "Cash",
  SERVICE: "Service",
  CREDIT: "Credit"
};

export const cardTypeMapping: Record<string, string> = {
  SHARED: "Shared",
  PRIVATE: "Private"
};

export const GROUP_TYPE = {
  SITE: "SITE",
  COST_CENTRE: "COST_CENTRE"
} as const;

export const groupTypeMapping: Record<string, string> = {
  [GROUP_TYPE.SITE]: "Site",
  [GROUP_TYPE.COST_CENTRE]: "Cost Centre"
};

export const ACTIVE_GROUP_FILTER = { group_filter: { group_status: "ACTIVE" } };

export const activeStatusMapping: Record<string, boolean> = {
  ACTIVE: true,
  INACTIVE: false
};

export const reverseActiveStatusMapping: Record<string, string> = {
  true: "ACTIVE",
  false: "INACTIVE"
};

export const REIMBURSEMENT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  SETTLED: "SETTLED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
} as const;

export const reimbursementStatusMapping: Record<string, string> = {
  [REIMBURSEMENT_STATUS.DRAFT]: "Draft",
  [REIMBURSEMENT_STATUS.SUBMITTED]: "Submitted",
  [REIMBURSEMENT_STATUS.APPROVED]: "Approved",
  [REIMBURSEMENT_STATUS.REJECTED]: "Rejected",
  [REIMBURSEMENT_STATUS.SETTLED]: "Settled",
  [REIMBURSEMENT_STATUS.COMPLETED]: "Completed",
  [REIMBURSEMENT_STATUS.CANCELLED]: "Cancelled"
};

export const REIMBURSEMENT_DESTINATION_WALLET_TYPES = ["GENERAL", "GROUP", "SERVICE"];

export const recurringTransferTypeMapping: Record<string, string> = {
  FIXED: "Fixed",
  TOPUP: "Top Up"
};

export const rolesCanBeAdded = [
  "ORGANISATION_SUPER_ADMIN",
  "SUPPORTER",
  "ORGANISATION_FINANCE_MANAGER",
  "ORGANISATION_OPERATIONS_MANAGER",
  "PARTICIPANT",
  "INTERNAL_ADMIN"
];
export const reverseRoleMapping: Record<string, string> = {
  ["Super Admin"]: "ORGANISATION_SUPER_ADMIN",
  ["Internal Admin"]: "INTERNAL_ADMIN",
  ["Participant"]: "PARTICIPANT",
  ["Supporter"]: "SUPPORTER",
  ["Operations Manager"]: "ORGANISATION_OPERATIONS_MANAGER",
  ["Guardian"]: "ORGANISATION_FINANCE_MANAGER"
};

export const walletUserRole = [PARTICIPANT, SUPER_ADMIN, OPERATIONS_MANAGER];

export const walletSpendFrequencyMapping: Record<string, string> = {
  NONE: "None",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  BIWEEKLY: "Fortnightly",
  MONTHLY: "Monthly"
};

export const walletResetLimitMapping: Record<string, string> = {
  "0": "Sunday",
  "1": "Monday",
  "2": "Tuesday",
  "3": "Wednesday",
  "4": "Thursday",
  "5": "Friday",
  "6": "Saturday"
};

export const cardStatusMapping: Record<string, string> = {
  ACTIVE: "Active",
  INACTIVE: "Blocked",
  BLOCKED: "Blocked",
  DRAFT: "Draft",
  CANCELED: "Canceled",
  HOLD: "Hold",
  ORDERED: "Ordered"
};

export const convertCardStatusToCardEventAction: Record<string, string> = {
  ACTIVE: "UNBLOCK",
  INACTIVE: "BLOCK",
  BLOCKED: "BLOCK",
  DRAFT: "DRAFT",
  CANCELED: "CANCEL",
  HOLD: "HOLD"
};

export const expenseTypeMapping: Record<string, string> = {
  OFFLINE: "Offline",
  GROUP: "Group",
  BILL: "Bill",
  CARD: "Card"
};

export const gstTypeMapping: Record<string, string> = {
  NONE: "None",
  INCLUDED: "Included",
  EXCLUDED: "Excluded"
};

export const CHUNK_FAILED_MESSAGE = "Failed to load a required script. Try reloading the page.";

export const fileProcessStatusMapping: Record<string, string> = {
  PENDING: "Pending",
  CREATED: "Created",
  INITIATED: "Initiated",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
  REJECTED: "Rejected"
};

export const settlementStatusMapping: Record<string, string> = {
  MATCHED: "Matched",
  MISMATCHED: "Mismatched",
  PARTIAL_MATCHED: "Partial Matched",
  NOVATTI_ONLY: "Novatti Only",
  SETTLED: "Settled",
  IGNORED: "Ignored"
};

export const SETTLEMENT_STATUS_VALUES = [
  "MATCHED",
  "MISMATCHED",
  "PARTIAL_MATCHED",
  "NOVATTI_ONLY",
  "SETTLED",
  "IGNORED"
];

// Matched against content.typeDesc, an exact-match keyword field — send verbatim, never re-cased.
export const NOVATTI_TRANSACTION_TYPE_VALUES = [
  "Purchase",
  "Cash",
  "Credit purchase",
  "Reverse purchase",
  "Reverse cash",
  "Reverse returns purchase"
];

export const IGNORE_REASON_OTHER = "OTHER";

export const ignoreReasonMapping: Record<string, string> = {
  FX_ARTEFACT: "FX artefact",
  IMMATERIAL: "Immaterial amount",
  STALE: "Too old or wallet closed",
  [IGNORE_REASON_OTHER]: "Other"
};

export const IGNORE_REASON_VALUES = ["FX_ARTEFACT", "IMMATERIAL", "STALE", IGNORE_REASON_OTHER];

export const fileTypeMapping: Record<string, string> = {
  CASH_TRANSACTION: "Cash transaction",
  DEPOSIT: "Deposit",
  NOVATTI_DAILY_TRANSACTION: "Novatti daily transaction",
  CREATE_USER: "Create user",
  UPDATE_ORGANISATION: "Update organisation",
  UPDATE_SUBSCRIPTION_TO_ORGANISATION_RELATIONSHIP: "Update subscription",
  UPDATE_MCC: "Update MCC",
  UPDATE_USER_PASSWORD: "Update user password",
  WALLET_ADJUSTMENT: "Wallet adjustment",
  CREATE_ATTRIBUTE_CATALOG: "Create attribute catalog",
  CREATE_GL_CODE: "Create GL code",
  CREATE_ACCOUNTING_CATEGORY: "Create accounting category",
  UPDATE_GL_CODE: "Update GL code",
  UPDATE_ACCOUNTING_CATEGORY: "Update accounting category",
  WALLET_ACCOUNTING_DEFAULTS: "Wallet accounting defaults"
};
